module.exports = __webpack_public_path__ + "media/images/workplace/patterns/4-4531c0a42524ea60d933f55bbdd4eb3e.png";